<div class="accordion-wrapper">
  <ng-container *ngIf="isTemplate">
    <app-restriction></app-restriction>
  </ng-container>
  <div class="group-fifteen">
    <mat-checkbox class="checkbox-parent" (change)="onSelectAllColumsInAllRows($event)" [checked]="selectAllTablesRows">
      <span class="input-labels all-label">Select All Columns For All Tables</span>
    </mat-checkbox>
  </div>
  <cdk-accordion class="example-accordion">
    <cdk-accordion-item
      *ngFor="let tab of field.fieldGroup; let index = index; let last = last"
      #accordionItem="cdkAccordionItem"
      class="example-accordion-item"
      role="button"
      tabindex="0"
      [attr.id]="'accordion-header-' + index"
      [attr.aria-expanded]="accordionItem.expanded"
      [attr.aria-controls]="'accordion-body-' + index"
    >
      <div class="example-accordion-item-header" (click)="accordionItem.toggle()">
        <div>
          {{ tab.key }}
          <span *ngIf="tab.props.isGreenTickRequired"> <i class="fa fa-check-circle text-success font-13"></i> </span>
          <span *ngIf="tab.props.advancedLoadingMode === 'UPSERT' ? !tab.props.pkSelected : false"> 
            <i matTooltip = 'Please choose atleast 1 Primary Key for upsert mode or change mode in the previous step' class="fa fa-exclamation-circle danger-icon font-13"></i>
          </span>
        </div>
        <span class="example-accordion-item-description">
          Click to {{ accordionItem.expanded ? 'close' : 'open' }}
        </span>
      </div>
      <div
        class="example-accordion-item-body"
        role="region"
        [style.display]="accordionItem.expanded ? '' : 'none'"
        [attr.id]="'accordion-body-' + index"
        [attr.aria-labelledby]="'accordion-header-' + index"
      >
        <formly-field [field]="tab"></formly-field>
      </div>
    </cdk-accordion-item>
  </cdk-accordion>
</div>